const Field: React.FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children,
}) => (
  <div className="flex flex-col gap-1.5 ">
    <label className="login-label font-primary">{label}</label>
    {children}
  </div>
);

export default Field;
